import { render } from "./OpenAIForm.vue?vue&type=template&id=a706f7ba&ts=true"
import script from "./OpenAIForm.vue?vue&type=script&lang=ts"
export * from "./OpenAIForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__